<template>

    <div>

      <v-app-bar app elevation="0">
        <v-btn icon text :to="'/'">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title class="title font-weight-bold">About Us</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon text>
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container>
        
        <v-card flat>
          <v-card-text>
            <p class="title primary--text">Selamat datang di Lexicon Syariah</p>
            <p class="body-2 text-justify">
              Saat ini, Ekonomi Islam di Indonesia mengalami perkembangan pembelajaran dan pelaksanaan yang pesat. Seiring dengan meningkatnya minat masyarakat terhadap Ekonomi Islam, aplikasi ini dibuat untuk memudahkan masyarakat dalam mengenal istilah-istilah di Ekonomi Islam yang didominasi dengan bahasa Arab. Selain itu, tambahan fitur yang ditujukan untuk memudahkan akses artikel jurnal tentang Ekonomi Islam juga menjadi unggulan dalam aplikasi ini. Harapan dari terbentuknya aplikasi ini adalah untuk memperkenalkan ekonomi islam serta memberikan kemudahan dalam kegiatan belajar baik untuk masyarakat umum maupun civitas akademika.
            </p>
            <p class="body-2 text-justify">
              Aplikasi ini masih dalam tahap pengembangan. Kritik dan saran anda akan sangat membantu kami dalam menyempurnakan Aplikasi Lexicon Syariah supaya dapat bermanfaat secara luas. Terima kasih telah mengunduh dan memakai Lexicon Syariah. Semoga aplikasi ini memberikan manfaat bagi pengembangan keilmuan Ekonomi Islam.
            </p>

            <p>
              Tim Pengembang:
              Jurusan Ekonomi Pembangunan Universitas Negeri Malang
              Email : ekp.fe@um.ac.id
            </p>

            <p>
              Penanggung Jawab Konten:
              Vika Annisa Qurrata, S.E.,M.E
              Email : vika.annisa.fe@um.ac.id
            </p>


            </p>
          </v-card-text>
        </v-card>

      </v-container>



    </div>
</template>

<script>

export default {
  name: 'About',
  components: {
  },

  data: () => ({
  }),
  async created () {
  },
  methods: {
  },
  computed: {
  }
}
</script>
